export const places = [
  {
    label: '背部',
    value: 40,
  }, {
    label: '肩部',
    value: 50,
  }, {
    label: '腰部',
    value: 60,
  }
]

export const powers = [
  {
    label: '轻柔',
    value: 1,
  }, {
    label: '适中',
    value: 2,
  }, {
    label: '加强',
    value: 4,
  }
]

export const commands = [
  {
    label: '开始',
    value: 1,
  }, {
    label: '结束',
    value: 4,
  }
]

export const startStates = [
  {
    label: '已开启',
    value: 1,
  }, {
    label: '已关闭',
    value: 2,
  }, {
    label: '离线',
    value: 3,
  }
]

export const steps = [
  {
    label: '待发布',
    value: 1,
  }, {
    label: '已发布',
    value: 2,
  }, {
    label: '已下架',
    value: 3,
  }
]

export default {
  places,
  powers,
  commands,
  startStates,
  steps,
}
